import React from "react";
import EmblaCarousel from "../../slider/ProdViewSlider/slider";
import "../../pages/ProductPreview.css";

// The Buyer product-preview gallery (main slide + arrows + counter + thumbnails), reused as-is.
// The provider's own `images` are the same relative URLs as Product.ProductImageUrls.
export default function ProductGallery({ images = [], title, infoSource }) {
  const slides = (images || []).filter(Boolean);
  return (
    <div className="pv-gallery">
      {slides.length ? <EmblaCarousel slides={slides} options={{}} title={title} infoSource={infoSource} /> : <div className="pv-gallery-ph" />}
    </div>
  );
}
